import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaRating from './VaRating.vue'
export { default as VaRatingItem } from './components/VaRatingItem'

export default withConfigTransport(VaRating)
